import { Form, Input } from "antd";

const TextField = ({ field }) => (
  <Form.Item
    hidden={field?.hidden}
    key={field.name}
    name={field.name}
    label={field.label}
    rules={field.rules}
    extra={field.extra}
  >
    <Input placeholder={field.placeholder} disabled={field.disabled} />
  </Form.Item>
);

export default TextField;
